import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validateCurp } from "../../api/validateCurp";
import { mtfindIdPersonByIdenti } from "../../api/mtfindIdPersonByIdenti";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import check from "../../assets/check_list.png";
import checkDone from "../../assets/ok_done.svg";
import checkDefault from "../../assets/ok_default.svg";
import Header from "../../Header/Header";
import App from "../../flags/flags";
import "./style.css";

function MyVerticallyCenteredModal(props) {

  const navigate = useNavigate();

  const onContinueClose = async () => {
    navigate("/PantallaBase");
  };
  const onContinueIden = async () => {
    navigate("/PantallaBase14");
  };

  const [onehabilita, setOnehabilita] = useState(true);

  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className="txtHead_P1">Política de Privacidad</span>
        </Modal.Title>
        <a onClick={onContinueClose} className="btn-close" role="button"></a>
      </Modal.Header>
      <Modal.Body>
        <p className="txtMsj_P1">
          En esta versión de Demostración, Sistema de Confiabilidad DPR SAPI
          borra todos los datos recabados al terminar la sesión. Nuestros
          Procesos de Certificación recaban Datos Personales para proporcionar
          los mejores servicios a todos nuestros Clientes. El tipo de datos que
          se recaban y se utilizan depende de las Operaciones Realizadas por el
          Usuario. Adicionalmente recabamos información sobre las aplicaciones,
          los navegadores y los dispositivos utilizados, esto permite asegurar
          la autenticidad, veracidad y legitimidad de los datos, así como
          incrementar la seguridad y ofrecer funciones avanzadas.
        </p>

        <div onClick={() => setOnehabilita(!onehabilita)}>
          <button className="buttonCookies_P1">
            {<img align="left" src={!onehabilita ? checkDone : checkDefault} />}
            <div className="txtCookies_P1">Aceptar Política de Privacidad</div>
          </button>
        </div>
        <br />
        <button
          className={!onehabilita ? "buttonModal_P1" : "buttonModal_disable"}
          onClick={props.onHide}
          disabled={onehabilita}
        >
          <div
            className={
              !onehabilita ? "txtButtonModal_P1" : "txtButtonModal_disable"
            }
            onClick={onContinueIden}
          >
            Confirmar
          </div>
        </button>
      </Modal.Body>
      <div className="foorterBackground_P1">
        <Modal.Footer>
          <span className="txtFooorter_P1">
            IMPORTANTE: Consulte nuestra{" "}
            <span className="txtCookiesFooorter_P1">
              {" "}
              <a href="https://midpr.icu/privacidad.php" target="_blank">
                Política de Privacidad
              </a>
            </span>{" "}
            para más detalles sobre la protección de datos.
          </span>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

function Pantalla3() {

  const navigate = useNavigate();
  const ref = useRef(null);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [game, setGame] = useState("1");
  const [curpStr, setCurpStr] = useState("");
  const [showHeader, setShowHeader] = useState(false);
  const [blContinueOp, setBlContinueOp] = useState("1");

  const handleClose = () => setShow(false);
  const onModalShow = () => setModalShow(true);

  useEffect(() => {
    if (curpStr.length < 18) {
      setBlContinueOp("1");
    }
  });

  const onValidateFaceMach = async () => {

    navigate("/FaceLoginPassaporte", {
      state: {
        rutaContinue: "/PantallaBase27",
        typeCredential: "lic"
      }
    });

  };

  const onValidateCurp = async () => {

    setShowHeader(false);
    setGame("2");

    const objValida = {
      curp: curpStr,
    };

    const response = await validateCurp(objValida);

    if (response.status === 200) {

      const objPerson = {
        identificationNumberId: curpStr,
      };

      const responseIdPerson = await mtfindIdPersonByIdenti(objPerson);

      if (responseIdPerson.status === 200) {
        setGame("3");
        setBlContinueOp("3");
        setShowHeader(false);
        localStorage.setItem("curpValidate", "" + curpStr);
      } else if (responseIdPerson.status === 400) {
        setGame("3");
        setBlContinueOp("4");
        localStorage.setItem('idPerson', '' + responseIdPerson.id);
      } else {
        setGame("1");
        setBlContinueOp("2");
        setShow(true);
        setShowStatus(responseIdPerson.status);
        setShowMessage(responseIdPerson.message);
      }

    } else {

      setGame("1");
      setBlContinueOp("2");
      setShow(true);
      setShowStatus(response.status);
      setShowMessage(response.message);

    }
  };

  const handleChange = (event) => {
    if (event.target.value.length < 19) {
      setCurpStr(event.target.value.toUpperCase());
    }

    if (event.target.value.length === 18) {
      setBlContinueOp("2");
    }
  };

  const handleClick = (event) => {
    if (document.activeElement === ref.current) {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  };

  const handkeOnKeyDown = async (event) => {
    if (
      event.code === "Enter" ||
      event.code === "NumpadEnter" ||
      event.keyCode === 13
    ) {
      onValidateCurp();
    }
  };

  return (
    <>
      {!showHeader ? (
        <>
          <Header
            imgBack={true}
            rutaBack="/PantallaBase"
            title="Identificación Personal"
            name="steepOne"
          />
        </>
      ) : (
        <></>
      )}

      <div className="containerInfo_P2">
        <div className="containerIdent_P2">
          <p className="txtNat_P3">Nacionalidad</p>
          <App />
          <br />
          <p className="txtNum_P3">Número de Identificación Nacional</p>
          {(() => {
            switch (game) {
              case "1":
                const style = {
                  borderColor: "#c4cbd1 !important",
                  display: "block",
                  width: "100%",
                  padding: "7px 0 7px 7px",
                  border: "1px solid #c4cbd1",
                  borderRadius: "0.375rem",
                  height: "52px",
                };

                return (
                  <>
                    <Form>
                      <input
                        style={style}
                        required={true}
                        maxLength={18}
                        type="text"
                        ref={ref}
                        placeholder="CURP"
                        value={curpStr}
                        onChange={handleChange}
                        onClick={handleClick}
                        onKeyDown={handkeOnKeyDown}
                      />
                    </Form>
                  </>
                );

              case "2":
                const style2 = {
                  borderColor: "#c4cbd1 !important",
                  display: "block",
                  width: "100%",
                  padding: "12px 0px 12px 15px",
                  border: "1px solid #c4cbd1",
                  borderRadius: "8px 0 0 8px",
                  height: "52px !important",
                };

                return (
                  <>
                    <div className="Row_P3">
                      <div className="Column_P3">
                        <Form.Control
                          style={style2}
                          required={true}
                          maxLength={18}
                          type="text"
                          ref={ref}
                          placeholder="CURP"
                          value={curpStr}
                          onChange={handleChange}
                          onClick={handleClick}
                          onKeyDown={handkeOnKeyDown}
                        />
                      </div>
                      <div className="Column1_P3 animate__animated myDiv_P3">
                        <div className="myDiv_P3_3">
                          <Spinner
                            className="spinerColor"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            variant="light"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                );
              case "3":
                const style3 = {
                  borderColor: "#c4cbd1 !important",
                  display: "block",
                  width: "100%",
                  padding: "12px 0px 12px 15px",
                  border: "1px solid #c4cbd1",
                  borderRadius: "8px 0 0 8px",
                  height: "52px !important",
                };
                return (
                  <>
                    <div className="Row_P3 ">
                      <div className="Column_P3">
                        <Form.Control
                          style={style3}
                          required={true}
                          maxLength={18}
                          type="text"
                          ref={ref}
                          placeholder="CURP"
                          value={curpStr}
                          onChange={handleChange}
                          onClick={handleClick}
                          onKeyDown={handkeOnKeyDown}
                        />
                      </div>
                      <div className="Column1_P3 animate__animated myDiv_P3">
                        <div className="myDiv_P3_3">
                          <img src={check} />
                        </div>
                      </div>
                    </div>
                  </>
                );
              case "4":
                return <></>;
              default:
                return null;
            }
          })()}

          {(() => {
            switch (blContinueOp) {
              case "1":
                return (
                  <>
                    <hr className="line" />
                    <button className="btnVer_P3">
                      <span className="txtVer_P3">Verificar</span>
                    </button>
                    <br />
                  </>
                );
              case "2":
                return (
                  <>
                    <hr className="line" />
                    <button
                      className="btnVer_P3_Select"
                      onClick={onValidateCurp}
                      onChange={handleClick}
                    >
                      <span className="txtVer_P3">Verificar</span>
                    </button>
                    <br />
                  </>
                );
              case "3":
                return (
                  <>
                    <hr className="line" />
                    <button
                      className="button_P2 animate__animated animate__fadeIn"
                      onClick={onModalShow}
                    >
                      <span className="txtButton_P2">Continuar</span>
                    </button>
                    <br />
                  </>
                );
              case "4":
                return (
                  <>
                    <hr className="line" />
                    <button
                      className="button_P2 animate__animated animate__fadeIn"
                      onClick={onValidateFaceMach}
                    >
                      <span className="txtButton_P2">Continuar</span>
                    </button>
                    <br />
                  </>
                );
              default:
                return null;
            }
          })()}

          {/* Preguntas....
                    <br /><br /><br />
                    <QuestionList /> */}
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className="backGroudModal">
          <div className="msjTitleModalDiv">Error {showStatus}</div>
          <div className="msjErrorModal">{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="button_P2" onClick={handleClose}>
            <span className="txtButton_P2">Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Pantalla3;
